// @mui
import { alpha, styled } from "@mui/material/styles"
import type { Theme } from "@mui/material/styles"
import SimpleBar from "simplebar-react"
import type { Props } from "simplebar-react"

import "simplebar-react/dist/simplebar.min.css"

// ----------------------------------------------------------------------

export const StyledRootScrollbar = styled("div")(() => ({
  flexGrow: 1,
  height: "100%",
  overflow: "hidden",
}))

interface StyledScrollbarProps extends Props {
  paddingbottom?: number
  paddingright?: number
}

export const StyledScrollbar = styled(SimpleBar)<StyledScrollbarProps>(
  ({
    theme,
    paddingbottom = 0,
    paddingright = 0,
  }: {
    theme: Theme
    paddingbottom?: number
    paddingright?: number
  }) => ({
    maxHeight: "100%",
    height: "100%",
    "& .simplebar-scrollbar": {
      "&:before": {
        backgroundColor: alpha(theme.palette.grey[600], 0.48),
      },
      "&.simplebar-visible:before": {
        opacity: 1,
      },
    },
    "& .simplebar-track.simplebar-vertical": {
      width: 10,
    },
    "& .simplebar-track.simplebar-horizontal .simplebar-scrollbar": {
      height: 10,
    },
    "& .simplebar-mask": {
      zIndex: "inherit",
    },
    "& .simplebar-offset": {
      paddingBottom: paddingbottom,
      paddingRight: paddingright,
    },
  })
)
